// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XJmx","buttons":"Footer_buttons__1xLOc"};